module.exports = __webpack_public_path__ + "static/media/fail.967af154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fail.png
// module id = 313
// module chunks = 1